module.exports = __webpack_public_path__ + "static/media/Horizantal_Nav_Top_Nomal Size_42x42.57b200a2.png";